import { api as bookingsApi } from './auto-generated/bookings'

bookingsApi.enhanceEndpoints({
  endpoints: {},
})

export { bookingsApi }
